export default {
  ["LOGIN"]: function(state, payload) {
    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("user", JSON.stringify(payload));
    state.isLoggedIn = true;
    state.user = payload;
  },
  ["LOGOUT"]: function(state) {
    localStorage.removeItem("isLoggedIn", "false");
    localStorage.removeItem("user");
    state.isLoggedIn = false;
    state.user = null;
  },
};
